import React, { useEffect, useMemo, useRef, useState } from 'react'
import wave from "../../assets/images/wave.svg";
import './styles.scss'
import ChatBox from 'components/ChatBox';
import { useAppSettings } from 'shared/context/AppSettingsContext';
import { languageService } from 'services';

const Conversation = ({ conversation, currentMessage }) => {
	const { text, language, sourceLanguageTranscriptionDir } = currentMessage;
	const [showCurrentText, setShowCurrentText] = useState(false)
	const appSettings = useAppSettings();
	const chatEndRef = useRef(null);

	const userSelectedSourceLanguage = useMemo(() => languageService.getLocale(appSettings.settings.sourceLanguage, appSettings.settings.sourceDialect), [appSettings.settings.sourceLanguage, appSettings.settings.sourceDialect]);

	useEffect(() => {
		scrollToBottom();
		setShowCurrentText(false)
	}, [conversation])

	useEffect(() => {
		if (text) {
			setShowCurrentText(true)
		} else {
			setShowCurrentText(false)
		}
	}, [text])

	const scrollToBottom = () => {
		chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
	}

	return (
		<div className='d-flex flex-column position-relative' id="chatContainer">
			<div className='wave'>
				<img
					src={wave}
					alt="wave"
				/>
			</div>
			<div>
				{conversation?.length > 0 && conversation?.map((message, i) => {
					if (message.sourceLanguage) {
						return <ChatBox
						 	key={i}
							type={userSelectedSourceLanguage.code === message.sourceLanguageCode ? 'dark' : 'light'}
							currentMessage={message.sourceLanguage}
							targetLanguage={message.targetLanguage}
							sourceLanguageTranscriptionDir={message.sourceLanguageTranscriptionDir}
							targetLanguageTranscriptionDir={message.targetLanguageTranscriptionDir}
							errorMessage={message.errorMessage}
						/>
					}
				})}
				{showCurrentText && (
					<ChatBox
						type={userSelectedSourceLanguage.code === language ? 'dark' : 'light'}
						currentMessage={text}
						sourceLanguageTranscriptionDir
					/>
				)}
				<div ref={chatEndRef} />
			</div>
		</div>
	)
}

export default Conversation;